import { useNavigate } from 'react-router-dom';
import { AnimatedPyramidLogo } from '@/components/landing/AnimatedLedgerLoop';
import { useAuthStore } from '@/hooks/useAuthStore';
import { OnboardingFlow } from '@/components/onboarding/OnboardingFlow';
import { PlatformTour } from '@/components/help/PlatformTour';
import { usePlatformTour } from '@/hooks/usePlatformTour';

const Onboarding = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { activeTour, runTour, completeTour } = usePlatformTour();

  const userName = user?.user_metadata?.first_name || user?.email?.split('@')[0] || 'there';

  const handleComplete = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 py-12">
      <div className="text-center space-y-3 mb-10">
        <AnimatedPyramidLogo variant="auth" />
        <h1 className="text-2xl font-semibold text-foreground">Welcome, {userName}</h1>
        <p className="text-sm text-muted-foreground">
          Let's set up your company and see what it's worth.
        </p>
      </div>

      <div className="w-full" data-tour="company-details">
        <OnboardingFlow onComplete={handleComplete} />
      </div>

      {activeTour === 'onboarding' && (
        <PlatformTour tourType="onboarding" run={runTour} onComplete={completeTour} />
      )}
    </div>
  );
};

export default Onboarding;
